import { render, staticRenderFns } from "./minimize-component.vue?vue&type=template&id=6516a050&scoped=true&"
import script from "./minimize-component.vue?vue&type=script&lang=js&"
export * from "./minimize-component.vue?vue&type=script&lang=js&"
import style0 from "./minimize-component.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./minimize-component.vue?vue&type=style&index=1&id=6516a050&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6516a050",
  null
  
)

export default component.exports